import type { ProLayoutProps } from '@ant-design/pro-components';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  colorPrimary: '#1677ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  pwa: true,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  splitMenus: true,
  siderWidth: 208,
  breadcrumbRender: false,
  menu: { defaultOpenAll: true, ignoreFlatMenu: true, autoClose: false },
  token: {
    header: {
      heightLayoutHeader: 44,
      colorBgHeader: 'var(--crm-nav-bg, #F0F0F3)',
      colorHeaderTitle: 'var(--crm-nav-text, #1F2633)',
      colorTextMenu: 'var(--crm-nav-muted, #596579)',
      colorTextMenuSelected: 'var(--crm-nav-text, #1F2633)',
      colorTextMenuActive: 'var(--crm-nav-text, #1F2633)',
      colorBgMenuItemSelected: 'transparent',
    },
    sider: {
      colorMenuBackground: 'var(--crm-nav-bg, #F0F0F3)',
      colorTextMenu: 'var(--crm-nav-muted, #596579)',
      colorTextMenuSelected: 'var(--crm-nav-text, #1F2633)',
      colorTextMenuActive: 'var(--crm-nav-text, #1F2633)',
      colorBgMenuItemSelected: 'var(--crm-nav-selected, rgba(0, 0, 0, 0.06))',
      colorBgMenuItemHover: 'var(--crm-nav-hover, rgba(0, 0, 0, 0.04))',
    },
    pageContainer: {
      colorBgPageContainer: '#ffffff',
      paddingBlockPageContainerContent: 16,
      paddingInlinePageContainerContent: 16,
    },
    bgLayout: '#ffffff',
  },
};
export default Settings;
